import {
  skeleton_styles_default
} from "./chunk.SKPPKK6K.js";
import {
  SlSkeleton
} from "./chunk.N27ZBSBG.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/skeleton/skeleton.ts
var FadvSkeleton = class extends SlSkeleton {
  updateShape() {
    var _a;
    const base = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector(".skeleton");
    base == null ? void 0 : base.classList.toggle("skeleton--square", this.shape === "square");
    base == null ? void 0 : base.classList.toggle("skeleton--circle", this.shape === "circle");
    base == null ? void 0 : base.classList.toggle("skeleton--triangle", this.shape === "triangle");
    base == null ? void 0 : base.classList.toggle("skeleton--cross", this.shape === "cross");
    base == null ? void 0 : base.classList.toggle("skeleton--comment", this.shape === "comment");
  }
  connectedCallback() {
    super.connectedCallback();
    setTimeout(() => this.updateShape());
  }
};
FadvSkeleton.styles = skeleton_styles_default;
__decorateClass([
  e()
], FadvSkeleton.prototype, "shape", 2);
__decorateClass([
  watch("shape")
], FadvSkeleton.prototype, "updateShape", 1);
FadvSkeleton = __decorateClass([
  n("fadv-skeleton")
], FadvSkeleton);

export {
  FadvSkeleton
};
